import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DeviceService } from 'src/app/services/devices/device.service';

@Component({
    selector: 'app-anc-channels',
    imports: [CommonModule, FormsModule, TranslateModule],
    templateUrl: './anc-channels.component.html'
})
export class AncChannelsComponent implements OnInit {

  @Input()
  allSettings = false;

  device = '';

  dataCfgDevice: any = { permanent: 0 };
  originalDataDevice: any;

  changesMade = false;
  successMessage = false;
  error = '';

  constructor(private _aRoute: ActivatedRoute, public _deviceService: DeviceService) { }

  ngOnInit(): void {
    this._aRoute.parent?.parent?.params
      .subscribe((params: Params) => this.device = params['serial']);

    this._deviceService.getModuleInfo(this.device, 'device').subscribe((data) => {
      this.originalDataDevice = { permanent: data.cfg?.permanent || 0 };
      this.dataCfgDevice = { ...this.originalDataDevice };
    });
  }

  changePermanentOutput(output: number, permanent: boolean) {
    this.dataCfgDevice.permanent = permanent
      ? this.dataCfgDevice.permanent | output
      : this.dataCfgDevice.permanent & ~output;
    this.changesMade = true;
  }

  save(): void {
    this._deviceService.setModuleCfg(this.device, { permanent: this.dataCfgDevice.permanent }, 'device').subscribe(() => {
      this.originalDataDevice = { ...this.dataCfgDevice };
      this.changesMade = false;
      this.successMessage = true;
      setTimeout(() => this.successMessage = false, 3000);
    }, err => {
      this.error = err.error?.message || '';
      setTimeout(() => this.error = '', 10000);
    });
  }

  restore(): void {
    this.dataCfgDevice = { ...this.originalDataDevice };
    this.changesMade = false;
  }

}
